import React, { useEffect } from 'react'
import List from './List'
import { useCardContext } from '../../../../../../components/Card/CardContext'
import { usePositionDetailsById, usePositionRatesById } from '../../../../../../queries'

interface BodyProps {
  id: number
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const details = usePositionDetailsById(id)
  const rates = usePositionRatesById(id)
  const cardContext = useCardContext()
  const formatedId = details?.id
  useEffect(() => {
    if (formatedId !== undefined && formatedId !== null) {
      cardContext.setTitle(`Position - ${formatedId}`)
    } else {
      cardContext.setTitle('Position')
    }
  }, [formatedId])
  return (
    <List details={details} rates={rates} />
  )
}

export default Body
